module.exports = __webpack_public_path__ + "fonts/DINPro-CondBlack.2e36241f.otf";